import Dispatcher from '../dispatcher';
import {actions} from '../constants/address/billing_address_actions';

export function setFirstNameAction(firstName) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_FIRST_NAME,
        payload: firstName
    });
}

export function setMarketingConsentAction(payload) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_MARKETING_CONSENT,
        payload,
    });
}

export function setLastNameAction(lastName) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_LAST_NAME,
        payload: lastName
    });
}

export function setEmailAction(email) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_EMAIL,
        payload: email
    });
}

export function setTelephoneAction(telephone) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_TELEPHONE,
        payload: telephone
    });
}

export function setInvalid(payload) {
    Dispatcher.handleBillingAddressAction({
        type: actions.SET_INVALID,
        payload: payload
    });
}

export function unsetInvalid(payload) {
    Dispatcher.handleBillingAddressAction({
        type: actions.UNSET_INVALID,
        payload: payload
    });
}

export function resetInvalid() {
    Dispatcher.handleBillingAddressAction({
        type: actions.RESET_INVALID,
    });
}
